import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSlider, toggleFormSlider } from '../../../../../redux/actions/sliders'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { IRootState } from '../../../../../redux/types'
import { Slider } from '../../models/sliders'
import dayjs from 'dayjs'

type TitleLanguages = {
  id: string
  title: string
}

type FormField = {
  key: string
  value: string | null
}

type UseSliderFormProps = {
  type: number
  sliderState: Slider
  titleLanguages: TitleLanguages[]
}

export const useSliderForm = ({ type, sliderState, titleLanguages }: UseSliderFormProps) => {
  const dispatch = useDispatch()
  const { showForm } = useSelector((state: IRootState) => state.slider)
  const { isValidForm } = useSelector((state: IRootState) => state.validator)

  useEffect(() => {
    if (isValidForm) {
      handleFormSubmission()
    }
  }, [isValidForm])

  const appendBasicFields = (formData: FormData, sliderState: Slider): void => {
    const basicFields: FormField[] = [
      { key: 'id', value: sliderState.id !== 0 ? String(sliderState.id) : '' },
      { key: 'title', value: sliderState.title },
      { key: 'type', value: sliderState.type !== null ? String(sliderState.type) : '' },
      { key: 'value', value: sliderState.value ?? '' },
      { key: 'order', value: String(sliderState.order) },
      { key: 'status', value: String(sliderState.status.id) },
      { key: 'visibility', value: String(sliderState.visibility) }
    ]

    basicFields.forEach(({ key, value }) => formData.append(key, value as any))
  }

  const appendFileField = (formData: FormData, sliderState: Slider): void => {
    if (sliderState.image) {
      formData.append('image', sliderState.image)
    } else {
      console.log('No hay imagen para añadir al FormData')
    }
  }

  const appendOptionalFields = (formData: FormData, sliderState: Slider): void => {
    const optionalFields = [
      { key: 'brand', value: sliderState.brand },
      { key: 'line', value: sliderState.line },
      { key: 'role', value: sliderState.role }
    ]

    optionalFields.forEach(field => {
      if (field.value) {
        formData.append(field.key, JSON.stringify(field.value))
      }
    })
  }

  const appendArrayFields = (formData: FormData, sliderState: Slider): void => {
    formData.append('countries', JSON.stringify(sliderState.countries))
    formData.append('languages', JSON.stringify(sliderState.languages))

    if (type === 2) {
      formData.append('titleLanguages', JSON.stringify(titleLanguages))
    }

    if (sliderState.internaltype !== null) {
      formData.append('internaltype', String(sliderState.internaltype))
    }
  }

  const appendDateFields = (formData: FormData): void => {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    formData.append('date_ini', sliderState.startDate ? dayjs(sliderState.startDate).format(dateFormat) : '')
    formData.append('date_end', sliderState.endDate ? dayjs(sliderState.endDate).format(dateFormat) : '')
  }

  const handleFormSubmission = () => {
    dispatch(resetFormValidator())
    const formData = new FormData()

    console.log(sliderState)

    appendBasicFields(formData, sliderState)
    appendOptionalFields(formData, sliderState)
    appendArrayFields(formData, sliderState)
    appendDateFields(formData)
    appendFileField(formData, sliderState)

    dispatch(createSlider(formData))
  }

  const handleSubmit = () => {
    console.log(sliderState)
    const validationRules = {
      title: [sliderState.title, 'required|max:50|min:2'],
      countries: [sliderState.countries, 'notempty'],
      languages: [sliderState.languages, 'notempty'],
      order: [sliderState.order, 'numeric']
    }

    if (sliderState.id === 0 || sliderState.id === null || sliderState.id === undefined) {
      Object.assign(validationRules, {
        image: [sliderState.image, 'required']
      })
    }

    if (type === 1 || type === 3) {
      Object.assign(validationRules, {
        role: [sliderState.role, 'required', 'addOn']
      })
    }

    if (type === 2) {
      Object.assign(validationRules, {
        titleLanguages: [titleLanguages, 'notempty', 'addOn']
      })
    }

    if (type === 1) {
      Object.assign(validationRules, {
        brand: [sliderState.brand, 'notempty']
      })
    }

    dispatch(formValidator(validationRules))
  }

  const handleCloseModalSlider = () => {
    dispatch(resetFormValidator())
    dispatch(toggleFormSlider())
  }

  return {
    showForm,
    handleSubmit,
    handleCloseModalSlider
  }
}
